// /Users/boyd/Dev/freegopos/my-web-app/src/utils/types.ts
import React, { useState, useCallback } from 'react';
import { useCart } from '../context/cartContext';
import { fetchProductsModifiers } from '../utils/api';
// import { motion } from 'framer-motion';
import { toast } from 'react-toastify'; // Import toast
// --- Import Context Hooks and Auth Utils ---
import { useAuth } from '../context/AuthContext';
import { useCustomerContext } from '../context/customerContext';
import { hasRole } from './auth'; // Assuming path is correct

// --- helpers / Utility Functions ---
export function toCapitalCase(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const displayPrice = (price: number) => {
    // Convert price to a number if it's not already
    const numericPrice = typeof price === 'number' ? price : parseFloat(price);

    let currencySymbol = 'RM ';

    const settingsStr = localStorage.getItem('settings');
    let licenseRegions = null;

    if (settingsStr) {
        try {
            const settings = JSON.parse(settingsStr);
            licenseRegions = settings.license_regions;
        } catch (e) {
            console.error('Failed to parse settings from localStorage:', e);
        }
    }

    // console.log('Currency Symbol licenseRegions[0]:', licenseRegions[0]);

    if (Array.isArray(licenseRegions) && licenseRegions[0] === "219") {
        currencySymbol = '฿ ';
    }

    // console.log('Currency Symbol:', licenseRegions, currencySymbol);

    // Check if numericPrice is valid
    if (!isNaN(numericPrice)) {
        return currencySymbol + numericPrice.toLocaleString('en-US', { minimumFractionDigits: 2 }); // Format to 2 decimal places
    }

    return 'N/A'; // Return a fallback value if price is invalid
};

// export function displayPrice(
//   price: number,
// //   regionId?: number,
// //   currency?: string
// ): string {



//   const settingsStr = localStorage.getItem('settings');
//   let licenseRegions = null;
//   if (settingsStr) {
//     try {
//       const settings = JSON.parse(settingsStr);
//       licenseRegions = settings.license_regions;
//     } catch (e) {
//       console.error('Failed to parse settings from localStorage:', e);
//     }
//   }

//   const regionId = licenseRegions ? licenseRegions[0] : null;

//   console.log('Region ID:', regionId);
// //   console.log('Currency:', currency);


//     let currency = 'MYR';
//   let currencySymbol = 'RM';
//   let locale = 'en-MY';

// //   if (currency) {
// //     // Use explicit currency if provided
// //     if (currency === 'THB') {
// //       currencySymbol = '฿';
// //       locale = 'th-TH';
// //     }
// //     // Add more currencies as needed
// //   } else if (regionId === 219) {
// //     // Thai region
// //     currencySymbol = '฿';
// //     locale = 'th-TH';
// //   }

//   // Option 1: Use Intl.NumberFormat for proper formatting
//   return new Intl.NumberFormat(locale, {
//     style: 'currency',
//     currency: currency || (licenseRegions && licenseRegions.includes("219") ? 'THB' : 'MYR'),
//     minimumFractionDigits: 2,
//   }).format(price);

//   // Option 2: Simple symbol
//   // return `${currencySymbol}${price.toLocaleString()}`;
// }

export const formatProductNameForUrl = (name: string) => {
    return name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')  // Replace non-alphanumeric characters with hyphens
        .replace(/-+$/, '');          // Remove trailing hyphens
};

// --- settings Functions ---

export interface appConfig {
    id: number,
    // tenant_id: f03d0f4e-366c-4e78-b9a3-eeef78d62197,
    title: string,
    shortname: string,
    first_name: string,
    last_name: string,
    identity_no: string,
    companyreg: string,
    tin: string,
    active: true,
    address: string,
    address_2: string,
    address_3: string,
    city: string,
    state: string,
    country: string,
    zip: string,
    phone: number,
    email: string,
    remark: string,
    domain: string,
    // db_database: string,
    // db_username: string,
    valid_starts: string,
    valid_ends: string,
    sst: number,
    service_charge: number,
    gst: number,
    themes: {
        theme_name: string;
        displayStockQty: boolean;
        displayRestockAt: boolean;
        displayPrice: boolean;
    }[],

    // deleted_at: null,
    // created_at: 2024-07-02T08:26:12.000000Z,
    // updated_at: 2024-09-10T09:53:57.000000Z


    // New license-related fields
    license_regions: string[] | null; // e.g., ["219"]
    license_key: string | null;
    license_modules: string[] | null; // e.g., ["MTier"]
    license_start_date: string | null; // e.g., "11-06-2025"
    license_end_date: string | null;   // e.g., "11-09-2025"

    // Include other existing fields from your CInfo table that are selected
    // For example, if you have these in your $settingColumns:
    // currencyName?: string; // Example, if you add it
    // currencySymbol?: string; // Example
    // sst_tax_rate?: number | null; // Example
    // service_charge_rate?: number | null; // Example
    // timezone?: string | null; // Example
}

// src/types/config.d.ts
export interface AppConfig {
    API_URL: string;
    COMPANY_NAME: string;
    DOMAIN_NAME: string;
    DOMAIN_URL: string;
    TENANT_ID: number;
    API_KEY: string;
}

export interface AuthContextType {
    isAuthenticated: boolean;
    user: User | null;
    login: (identifier: string, password?: string, isGoogleLogin?: boolean) => Promise<User>;
    logout: () => void;
    loadingAuth: boolean;
    completePhoneOtpLogin: (
        appToken: string,
        userData: User,
        rolesPermsData: any,
        customerData?: any
    ) => void; // Or Promise<void> if it becomes async
}


export interface User {
    user_uuid: string;
    id: number;
    name: string;
    email: string;
    phone_country_code: string;
    phone: string;
    role: string; // <-- Make sure 'role' is included based on your API response
    remember_token?: string; // The token used for authentication
    // Add any other relevant fields from your API's user object
    customer?: any; // If customer data is nested under user
}


export interface Customer {
    id: number;
    name: string;
    email: string;
    phone: string;
    city: string;
    // other fields
    user_id: number;
    role: string; // Ensure this exists and is used
    // roles?: string[]; // Alternatively, if a user can have multiple roles
    country: string;
    state: string;

    first_name: string;
    last_name: string;

    // }
    // export interface Customer {
    // id: number;

    customer_uuid: string;
    // user_id: number;
    company_id: number;
    title: string;
    // name: string;


    // first_name: string;
    // last_name: string;

    msic_code: string;
    badesc: string;

    sstrn: string;
    ttrn: string;

    buyer_tin: string;
    buyer_code: string;
    seller_tin: string;
    seller_code: string;
    identity_no: string;
    identity_type: string;
    dob: Date; // or Date if you plan to convert it
    position: string;
    active: boolean;

    address: string;
    address_2: string;
    address_3: string;
    // city: string;
    // state: string;
    // country: string;
    zip: string;

    // phone: string;
    phone_2: string;
    // email: string;
    email_2: string;
    website: string;

    remark: string;
}

// Product related

// New type for Product with imageRef
export interface ProductWithImageRef extends Product {
    imageRef?: React.RefObject<HTMLImageElement>;
    quantity?: number; // Add optional quantity to store the intended quantity

}

export interface ProductCardProps {
    product: Product;
    imageRef?: React.RefObject<HTMLImageElement>; // Add optional imageRef here

}

export interface Category {
    id: number;
    cat_parent?: number | string | null; // Updated to handle string parent IDs from API
    cat_name: string;
    cat_prod_qty: number;
}

// /src/utils/types.ts
export interface Brand {
    id: number;
    cat_name: string;
    brand_prod_qty: number;
}

export interface Media {
    id: number;
    original_url: string;
    preview_url: string;
    // Add other properties from media if needed
};

export interface StockLocation {
    location_id: string;
    location_name: string;
    qty: number;
    min_qty: number;
    rack_code?: string;
    rack_level?: string;
    side?: string;
    box_code?: string;
}


export type ProductFlag = "NEW" | "PROMOTION" | "HOT";

export interface Product {
    id: number;
    media: Media[]; // Update this to be an array of Media objects
    original_url: string;
    preview_url: string;
    product_code: string;
    product_name: string;
    product_desc: string;
    product_value: number;
    brand: number;
    MTPrice: number;
    // MTPriceArray: { price: number; cat_name: string }[]; // Updated structure
    MTPriceArray: { price: number; cat_name: string }[]; // Updated structure
    product_cat: number;
    cat_name: string;
    brand_name: string;
    product_link: string;
    details: string;
    warranty: string;
    stock: number;
    restock: number;
    restock_at: string;
    // Add any other properties your product may have
    stock_by_location: { [locationId: string]: number }; // live stock per location
    total_quantity: number; // sum of all locations (backend now provides this)    
    product_uuid: string; // Unique identifier for the product

    //abb 14-8-25
    //   stock_by_location: StockLocation[];

    //abb 250828
    is_promotion: boolean;
    is_hot: boolean;
    is_new: boolean;
    is_promotion_active: boolean;
    is_hot_active: boolean;
    is_new_active: boolean;
    flags: ProductFlag[];
    SRP: number; // Suggested Retail Price abb 251004
};


// --- ProductSelectionModal Component (New) ---
export interface ProductSelectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onProductSelect: (product: Product, quantity: number, price: number) => void;
    customer: Customer; // To determine customer-specific pricing
}

// Cart related
// CartItem interface represents an item in the shopping cart

export interface CartItem {
    cartItemId: string; // Unique ID for each cart item
    id: number; // product id
    product_category: number;
    product_id: number;
    product_code: string;
    product_name: string;
    product_value: number;

    price: number;
    quantity: number; // This is where the quantity of the item in the cart is stored
    payment_for: string;
    modifiers: Modifier[]; // Add modifiers to the cart item
    // imageRef?: React.RefObject<HTMLImageElement>; // Add imageRef to CartItem
    customer_id?: number; // Added to associate cart item with a customer
}

// New Modifier interface 250323
export interface Modifier {
    id: number;
    product_id: number;
    product_name: string;
    product_value: number;
    // Add other properties as needed

    // id: number;
    user_id: number;
    media_id: number | null;
    product_uuid: string;
    product_code: string;
    product_code1: string | null;
    product_code2: string | null;
    product_code3: string | null;
    // product_name: string;
    product_desc: string | null;
    product_type: string | null;
    product_cat: string;
    product_addon_cat: number[];  //string[];
    product_unit_m: string;
    // product_value: string;
    product_link: string | null;
    product_path: string | null;
    brand: string | null;
    warranty: string;
    details: string | null;
    stock: number | null;
    restock: number | null;
    restock_at: string;
    active: boolean;
    cond: boolean;
    is_modifier: boolean;
    vat_active: boolean;
    approved_by: string | null;
    approved_at: string;
    remark: string | null;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    vat_price: string;
    vat_tax: string;
}

export interface CartState {
    items: CartItem[];
}

export interface CartAction {
    type: string;
    payload: CartItem | CartItem[];
}

export interface CartProviderProps {
    children: React.ReactNode;
}

// --- Order Summary and Order Item Interfaces ---

// abb 251012
export interface FulfillmentDetails {
    id: number;
    fulfillment_type: 'pickup' | 'delivery';
    pickup_time_slot?: string;
    picker_name?: string;
    picker_phone?: string;
    picker_car_plate?: string;
    // ... other fields
}

export interface OrderSummary {
    id: number;
    vendor_id: number; // owner shop id
    customer_id: number | null;
    order_type: string;
    table_id: number | null;
    items: OrderItem[]; // u8 Tranx id related to this order

    status: string;

    amount_to_pay: number;
    user_id: number;
    // table: TableDetails | null;

    total_taxes: string | null;
    receivable: string | null;
    rounding_value: string | null;
    rounded_receivable: string | null;
    received_amount: string | null;
    change: string | null;
    service_charges: string | null;
    total_amount: string | null;

    totalAmount: number;
    totalWithTax: number;
    totalTax: number;
    roundingDifference: number;

    created_at: string;
    updated_at: string;

    //abb 22-1-25
    balance: number;

    // process_log: string; // New field for process log

    order_uuid: string;

    //abb 251012
    fulfillment?: FulfillmentDetails | null; // Add this line

}

//abb 22-1-25
export interface OrderItem {

    id?: number;

    order_id: number;
    customer_id: number;

    product_id: number;
    product_code: string;

    product_name: string;
    product_category: number;
    quantity: number;
    product_value: number;

    price: number;
    total_price: number;
    // discount: string;
    // tax: string;
    // created_at: string;
    // updated_at: string;
    // deleted_at: string | null;

    // id: number;
    // // vendor_id: number;
    // order_id: number;
    // product_id: number;
    // product_name: string;
    // product_category: number;
    // price: string;
    // quantity: number;
    // total_price: string;
    // modifires: string;
    // // add_ons: string;
    // // toppings: string;
    // status: string;
    // items: string;
    // created_at: string;
    // updated_at: string;
    // // product: ProductDetails;
    // // specifications: Specification[];

    //abb 21-1-25
    payment_desc: string;
    payment_for: string;
    balance: number;
    unit_price: number;
    qty: number;
    tranx_details: string;
    category_id: number;

    // //abb 250214
    // print_to_location: string;

    modifiers: Modifier[]; // Add modifiers to OrderItem
    checkout: boolean;


    deleted_at?: string | null; // Optional: to track if the item was deleted
}

// Add this interface within src/pages/Order.tsx or in your src/utils/types.ts
export interface OrderItemData {
    orderItemId?: number; // The ID of the order_item record if it exists

    productId: number;
    productName: string;
    productCode: string; // SKU
    // payment_desc: string;
    // payment_for: string;
    quantity: number;
    unitPrice: number;   // Price for one unit of the product in this specific order
    totalPrice: number;  // quantity * unitPrice
    productValue: number; // Original SRP, for reference
    // Optional: Add fields for modifiers if your products have them
    // modifiers?: SelectedModifier[];
}

export interface InvoiceSummary {
    id: number;
    vendor_id: number; // owner shop id
    customer_id: number | null;
    order_type: string;
    table_id: number | null;
    items: InvoiceItem[]; // u8 Tranx id related to this order

    status: string;

    amount_to_pay: number;
    user_id: number;
    // table: TableDetails | null;

    total_taxes: string | null;
    receivable: string | null;
    rounding_value: string | null;
    rounded_receivable: string | null;
    received_amount: string | null;
    change: string | null;
    service_charges: string | null;
    total_amount: string | null;

    totalAmount: number;
    totalWithTax: number;
    totalTax: number;
    roundingDifference: number;

    created_at: string;
    updated_at: string;

    //abb 22-1-25
    balance: number;

    // process_log: string; // New field for process log
    invoice_uuid: string;
}

export interface Invoice {
    id: number;
    user_id: number;
    customer_id: number;
    company_id: number;
    order_id: number;
    invoice_uuid: string;
    unit_price: number;
    subtotal: number;
    balance: number;
    unit_price_vat: number;
    subtotal_vat: number;
    subtotal_sst: number;
    balance_taxinc: number;
    sst_tax: number;
    vat_tax: number;
    credit: number;
    debit: number;
    debit_pretax_amt: number;
    debit_tax_amt: number;
    debit_sst: number;
    debit_vat: number;
    credit_pretax_amt: number;
    credit_tax_amt: number;
    credit_sst: number;
    credit_vat: number;
    other_tax: number;
    discount: number;
    service_charge: number;
    alljson: string;
    process_log: string;
    completed: boolean;
    completed_on: string;

    remark: string;
    paymethod: string;
    paynumber: string;
    payexpdate: string;

    branch_id: number;
    branch_name: string;

    created_at: string;
    updated_at: string;
    deleted_at?: string | null;

    items: InvoiceItem[]; // u8 Tranx id related to this order

}

export interface InvoiceItem {

    // below is backup abb 250423
    // id: number;
    // order_id: number;
    // invoice_id: number;
    // customer_id: number;

    // product_id: number;
    // product_code: string;

    // product_name: string;
    // product_category: number;
    // quantity: number;
    qty: number;
    product_value: number;

    price: number;
    // total_price: number;

    //abb 21-1-25
    // payment_desc: string;
    // payment_for: string;
    // balance: number;
    // unit_price: number;
    // qty: number;
    // tranx_details: string;
    // category_id: number;
    // modifiers: Modifier[]; // Add modifiers to InvoiceItem
    // checkout: boolean;

    //new below abb250423
    id: number;
    order_id: number;
    invoice_id: number;
    customer_id: number;

    product_id: number;
    product_code: string;
    product_name: string; // Corresponds to "Description of Product or Service"
    product_category: number;
    quantity: number; // Corresponds to "Quantity"
    measurement_unit?: string; // Add if you track units like 'PCS', 'KG' etc. for "Measurement"
    unit_price: number; // Corresponds to "Unit Price"
    total_price: number; // Corresponds to "Total Sales Amount" (before discounts/fees/taxes)

    // MyInvois Specific Fields (Add based on your API/DB structure)
    classification_code?: string; // e.g., '01' for Standard Rate
    tariff_code?: string; // e.g., HS Code
    discount_rate?: number; // e.g., 0.10 for 10%
    discount_amount?: number; // Calculated or stored discount amount
    discount_desc?: string; // Description for discount
    fee_rate?: number; // e.g., 0.05 for 5%
    fee_amount?: number; // Calculated or stored fee amount
    fee_desc?: string; // Description for fee/charge
    tax_type?: string; // e.g., 'SST', 'VAT', 'Exempt'
    tax_rate?: number; // e.g., 0.06 for 6%
    tax_amount?: number; // Calculated or stored tax amount
    tax_exemption_amount?: number; // Amount Exempted From Tax
    tax_exemption_code?: string; // Code for exemption reason
    tax_exemption_details?: string; // Details of Tax Exemption
    total_excluding_tax?: number; // Calculated: total_price - discount_amount + fee_amount
    country_of_origin?: string; // e.g., 'MY'

    // Existing fields (review if needed)
    description: string; // Use 'description' key

    payment_desc: string;
    payment_for: string;
    balance: number;
    tranx_details: string;
    category_id: number;
    modifiers: Modifier[];
    checkout: boolean;

    // You might need calculated fields from the backend or calculate them here
    // total_sales_amount: number; // Often same as total_price before tax/discount
    // total_taxable_amount: number; // total_excluding_tax - tax_exemption_amount
}

// --- API Response Interfaces for Locations ---
export interface ApiCity {
    id: number; // Or string, depending on your API
    name: string;
    // Add other relevant city properties if needed
}

export interface ApiState {
    id: number; // Or string
    name: string;
    cities: ApiCity[]; // Eager loaded cities
    // Add other relevant state properties if needed
}

export interface ApiCountry {
    id: number; // Or string
    name: string;
    code: string; // e.g., 'MY', 'SG' - useful for matching
    phonecode: string; // e.g., '+60' - can reuse this!
    states: ApiState[]; // Eager loaded states
    // Add other relevant country properties if needed
    iso3: string;
    iso2: string;
}

// Interface for the overall API response if it's wrapped
export interface LocationsApiResponse {
    data: ApiCountry[];
    // Add other potential response fields like pagination, status, etc.
}

//  --- useHandleAddToCart Hook ---
// This is the hook you're looking for.
export const useHandleAddToCart = () => {
    const { dispatch } = useCart();
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<ProductWithImageRef | null>(null);
    const [modifiers, setModifiers] = useState<Modifier[]>([]);
    const [selectedModifiers, setSelectedModifiers] = useState<Modifier[]>([]);
    const [animationQueue, setAnimationQueue] = useState<{ product: ProductWithImageRef, imageRef: React.RefObject<HTMLImageElement> }[]>([]);

    // --- Get Contexts for Effective User Calculation ---
    const { user: loggedInUser } = useAuth();
    const { selectedSessionCustomer } = useCustomerContext();

    const getEffectiveUserDetails = useCallback(() => {
        const isAdminOrStaff = hasRole(['super_admin', 'staff', 'technician']);
        const isAdminActingAs = isAdminOrStaff && selectedSessionCustomer;

        if (isAdminActingAs) {
            const customerRole = selectedSessionCustomer?.role || 'dealer';
            return {
                id: selectedSessionCustomer.user_id,
                role: customerRole,
                isAuthenticated: true,
                customer_id: selectedSessionCustomer.id
            };
        } else {
            let loggedInUserRole: string | undefined;
            try {
                const rolesPermissionsItem = localStorage.getItem('rolesPermissions');
                if (rolesPermissionsItem) {
                    const rolesPermissions = JSON.parse(rolesPermissionsItem);
                    loggedInUserRole = rolesPermissions?.roles?.[0];
                }
            } catch (e) { console.error("Failed to parse rolesPermissions in useHandleAddToCart:", e); }
            return {
                id: loggedInUser?.id,
                role: loggedInUserRole,
                isAuthenticated: !!loggedInUser,
                customer_id: loggedInUser?.customer?.id || loggedInUser?.id
            };
        }
    }, [loggedInUser, selectedSessionCustomer]);


    // --- THIS IS THE addToCart FUNCTION ---
    // It's called by handleAddToCart (for no-modifier items)
    // and handleConfirmModifiers (for items with modifiers).
    // We add the 'quantity' parameter here.
    const addToCart = useCallback((
        product: ProductWithImageRef,
        modifiers: Modifier[],
        imageRef: React.RefObject<HTMLImageElement> | undefined,
        price: number,
        userId: number | undefined,
        userRole: string | undefined,
        customerId: number | undefined,
        quantity: number = 1 // <<<<====== ADDED quantity PARAMETER HERE (defaults to 1)
    ) => {
        const modifierIds = modifiers.map(m => m.id).sort().join('-');
        // cartItemId should be unique for product + specific set of modifiers
        const cartItemId = `${product.id}-${modifierIds || 'base'}`; // Removed Date.now() for consistent ID for same item config

        if (customerId === undefined) {
            console.error("Cannot add to cart: Customer ID is undefined.");
            toast.error("An error occurred. Customer information missing.");
            return;
        }

        dispatch({
            type: 'ADD_TO_CART',
            payload: {
                cartItemId: cartItemId,
                id: product.id,
                product_id: product.id,
                product_category: product.product_cat,
                product_code: product.product_code,
                product_name: product.product_name,
                product_value: product.product_value,
                price: price,
                quantity: quantity, // <<<<====== USE THE PASSED quantity HERE
                modifiers: modifiers,
                payment_for: 'product',
                customer_id: customerId,
            } as CartItem,
        });

        if (imageRef?.current) {
            setAnimationQueue(prevQueue => [...prevQueue, { product, imageRef }]);
        }

        toast.info(`${product.product_name} added to cart! (Qty: ${quantity})`, { // Show quantity in toast
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }, [dispatch, setAnimationQueue]); // Dependencies of addToCart


    // --- THIS IS THE handleAddToCart FUNCTION ---
    // It's defined inside the useHandleAddToCart hook.
    // We add the 'quantity' parameter here.
    const handleAddToCart = useCallback(async (
        product: Product,
        imageRef?: React.RefObject<HTMLImageElement>,
        priceToAdd?: number,
        effectiveUserId?: number,
        effectiveUserRole?: string,
        quantity: number = 1 // <<<<====== ADDED quantity PARAMETER HERE (defaults to 1)
    ) => {
        const effectiveUser = getEffectiveUserDetails();
        const userId = effectiveUserId ?? effectiveUser.id;
        const userRole = effectiveUserRole ?? effectiveUser.role;
        const finalPriceToAdd = priceToAdd ?? product.product_value;

        if (!effectiveUser.isAuthenticated || !userId || !userRole) {
            toast.error("Please log in to add items to the cart.");
            console.error("Add to cart failed: User not authenticated or details missing.");
            return;
        }

        try {
            const response = await fetchProductsModifiers(product.id, 2);
            if (response.data && response.data.length > 0) {
                setModifiers(response.data);
                setSelectedProduct({
                    ...product,
                    imageRef,
                    MTPrice: finalPriceToAdd,
                    quantity: quantity, // Store the quantity when setting selectedProduct

                });
                setShowModifierModal(true);
                // Note: If modifiers are chosen, the quantity will be passed from handleConfirmModifiers
                // to addToCart. For now, we don't pass quantity directly here if modal opens.
                // The quantity from ProductCard/ProductModal will be used if no modifiers.
            } else {
                // No modifiers, add directly to cart, using the passed quantity
                addToCart(
                    // { ...product, imageRef },
                    { ...product, imageRef, quantity: quantity }, // Pass product with quantity

                    [],
                    imageRef,
                    finalPriceToAdd,
                    userId,
                    userRole,
                    effectiveUser.customer_id,
                    quantity // <<<<====== PASS quantity TO addToCart HERE
                );
            }
        } catch (error) {
            console.error('Error fetching modifiers or adding to cart:', error);
            toast.error("Failed to add item to cart.");
        }

    }, [getEffectiveUserDetails, addToCart, setModifiers, setSelectedProduct, setShowModifierModal]); // Correct dependencies

    const handleCloseModifierModal = useCallback(() => {
        setShowModifierModal(false);
        setSelectedProduct(null);
        setModifiers([]);
        setSelectedModifiers([]);
    }, []);

    const handleModifierSelection = (modifier: Modifier) => {
        setSelectedModifiers((prevSelected) => {
            const isSelected = prevSelected.some((m) => m.id === modifier.id);
            if (isSelected) {
                return prevSelected.filter((m) => m.id !== modifier.id);
            } else {
                let newSelection = [...prevSelected];
                if (modifier.cond) {
                    newSelection = newSelection.filter(m => !m.cond);
                }
                return [...newSelection, modifier];
            }
        });
    };

    const handleConfirmModifiers = useCallback(() => {
        if (selectedProduct) {
            const effectiveUser = getEffectiveUserDetails();
            if (!effectiveUser.isAuthenticated || !effectiveUser.id || !effectiveUser.role) {
                toast.error("User details missing, cannot confirm modifiers.");
                console.error("Confirm modifiers failed: User details missing.");
                handleCloseModifierModal();
                return;
            }

            const basePrice = selectedProduct.MTPrice ?? selectedProduct.product_value;
            let modifierTotalPrice = 0;
            let hasCondTrue = false;
            selectedModifiers.forEach(modifier => {
                const modifierValue = Number(modifier.product_value) || 0;
                if (modifier.cond) {
                    if (!hasCondTrue) {
                        modifierTotalPrice += modifierValue;
                        hasCondTrue = true;
                    }
                } else {
                    modifierTotalPrice += modifierValue;
                }
            });
            const finalPrice = Number(basePrice) + modifierTotalPrice;
            // Use the quantity stored in selectedProduct (from the initial handleAddToCart call),
            // otherwise default to 1.
            const quantityToUse = selectedProduct.quantity ?? 1;


            addToCart(
                selectedProduct,
                selectedModifiers,
                selectedProduct.imageRef,
                finalPrice,
                effectiveUser.id,
                effectiveUser.role,
                effectiveUser.customer_id,
                quantityToUse // Use the quantity that was set when the modifier modal was triggered

            );
        }
        handleCloseModifierModal();
    }, [selectedProduct, selectedModifiers, getEffectiveUserDetails, addToCart, handleCloseModifierModal]); // Correct dependencies


    return {
        handleAddToCart,
        showModifierModal,
        handleCloseModifierModal,
        modifiers,
        selectedProduct,
        handleModifierSelection,
        handleConfirmModifiers,
        selectedModifiers,
        animationQueue,
    };
};

export interface QrDecodedData {
    action: string;
    id: string;
    [key: string]: any;
}



export interface ScanHistoryItem {
    type: 'user' | 'item';
    name?: string;
    email?: string;
    product_name?: string;
    product_code?: string;
    product_value?: string;
    stock_by_location?: { [locationId: string]: number };
}

// export interface QrStockOutPayload {
//   user_id: string | number;
//   product_id: string | number;
//   item_id: string | number;
//   quantity: number;
//   scan_history_id?: string | number; // optional
//   location_id?: string | number; // optional
//   reason?: string; // optional
// }

export interface QrStockOutPayload {
    scan_history_id: number,
    subject: string;
    user_id: string;
    location_id?: number;
    reason?: string;
    items: {
        product_id: number;
        item_id: string;
        quantity: number;
        scan_history_id?: number;
    }[];
}

export interface QrStockInPayload {
    scan_history_id: number,
    subject: string;
    user_id: string;
    location_id?: number;
    reason?: string;
    items: {
        product_id: number;
        item_id: string;
        quantity: number;
        scan_history_id?: number;
    }[];
}

export interface StockItem {
    id: number;
    product_code: string;
    sku: string; // Assuming SKU is a string
    stock: number;
    stock_by_location: { [key: string]: number } | null;
    product_name: string;
    // Add other fields as needed
}

export interface PaginatedStockResponse {
    current_page: number;
    data: StockItem[];
    last_page: number;
    next_page_url: string | null;
    prev_page_url: string | null;
    total: number;
}

export interface PaginatedScanHistoryResponse {
    current_page: number;
    data: ScanHistory[];
    last_page: number;
    next_page_url: string | null;
    prev_page_url: string | null;
    total: number;
}

export interface ScanHistory {
    id: number;
    subject: string;
    user_id: number;
    stock_location_id: number;
    status: string;
    confirmed_by: number; // Optional field for who confirmed the scan
    movement_type: string; // e.g., 'stock_in', 'stock_out'
    scanned_at: string;
    confirmed_at?: string; // Optional field
    created_at: string;
    updated_at: string;
    deleted_at?: string | null; // Optional field for soft delete

    //abb 251022
    item_count: number;
}

// export interface scan_histories {
//     id: number;
//     user_id: number;
//     stock_location_id: number;
//     status: string;
//     confirmed_by?: number; // Optional field for who confirmed the scan
//     movement_type: string; // e.g., 'stock_in', 'stock_out'
//     scanned_at: string;
//     confirmed_at: string;
//     created_at: string;
//     updated_at: string;
// }

// //{
//     "id": 2,
//     "title": "test title",
//     "description": "xvdf segs sfgd",
//     "reminder_at": "2025-12-09T14:37:00.000000Z",
//     "is_completed": false,
//     "created_at": "2025-12-07T09:38:06.000000Z",
//     "updated_at": "2025-12-07T09:38:06.000000Z"

export interface TaskReminder {
    id: number;
    title: string;
    description: string;
    reminder_at: string; // ISO date string
    is_completed: boolean;
    created_at: string; // ISO date string
    updated_at: string; // ISO date string
}